import React from 'react';
// import Title from '../Stateless/Title';
import StoreOwnerTable from './StoreOwnerTable';
import { Typography } from '@mui/material';
const StoreOwner: React.FC = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Store Owner Management
      </Typography>
      <StoreOwnerTable />
    </>
  );
};

export default StoreOwner;
